export interface RegionalBan {
  id: string;
  species: string;
  region: string;
  banStart: string; // ISO date
  banEnd: string; // ISO date
  regulatorySource: string;
  sourceUrl?: string;
}

// A generic, evergreen, self-descriptive operational commitment — same
// register as About.tsx's Commitments section and Compliance.tsx's practice
// cards. Not a claim about any specific current ban, so it's safe to state
// as a standing policy rather than data that can go stale.
export const BAN_POLICY_STATEMENT =
  "ZenFresh does not source or sell any species from a region currently under an official seasonal fishing ban, in line with the applicable State Marine Fishing Regulation Act. Affected partner crews are supported through our Monsoon Support Fund for the duration of the ban.";

// TODO(backend): populate from a real internal ban-tracking feed once one
// exists. Deliberately empty rather than a real-but-illustrative example —
// India's seasonal fishing bans (e.g. the west-coast monsoon trawling ban)
// are real and well documented, but exact dates and affected species vary
// by state and year. Asserting a specific "currently banned" list without a
// live, authoritative source risks presenting stale or wrong regulatory
// information as current fact — a reader could reasonably act on this,
// which makes it a sharper honesty risk than a marketing claim.
// FishingBanStatement.tsx shows the evergreen policy statement above
// unconditionally, and a "being integrated from internal tracking" state for
// this list while it's empty.
export const CURRENTLY_BANNED_SPECIES: RegionalBan[] = [];
